// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client'
import { client } from './client.gen'
import {
  getActivityResponseTransformer,
  getAuthSessionResponseTransformer,
  getCompaniesByIdActivityResponseTransformer,
  getCompaniesByIdDocumentsResponseTransformer,
  getCompaniesByIdHistoryResponseTransformer,
  getCompaniesByIdProjectsResponseTransformer,
  getCompaniesByIdResponseTransformer,
  getCompaniesResponseTransformer,
  getGroupsResponseTransformer,
  getOrganizationsResponseTransformer,
  getPermissionsAuditResponseTransformer,
  getRolesByIdResponseTransformer,
  getRolesResponseTransformer,
  getUsersByIdPermissionsEffectiveResponseTransformer,
  getUsersByIdResponseTransformer,
  getUsersMeResponseTransformer,
  getUsersResponseTransformer,
  patchCompaniesByIdResponseTransformer,
  patchGroupsByIdResponseTransformer,
  patchRolesByIdResponseTransformer,
  patchUsersByIdResponseTransformer,
  patchUsersMeResponseTransformer,
  postAuthLoginResponseTransformer,
  postAuthRefreshResponseTransformer,
  postCompaniesByIdDocumentsResponseTransformer,
  postCompaniesResponseTransformer,
  postGroupsResponseTransformer,
  postOrganizationsActiveResponseTransformer,
  postOrganizationsResponseTransformer,
  postRolesResponseTransformer,
  postUsersByIdPermissionsDenyResponseTransformer,
  postUsersByIdPermissionsGrantResponseTransformer,
  postUsersResponseTransformer,
} from './transformers.gen'
import type {
  DeleteCompaniesByIdData,
  DeleteCompaniesByIdDocumentsByDocumentIdData,
  DeleteGroupsByIdData,
  DeleteGroupsByIdMembersByUserIdData,
  DeleteRolesByIdData,
  DeleteUsersByIdPermissionsByGrantIdData,
  GetActivityData,
  GetActivityResponses,
  GetApiDashboardData,
  GetApiDashboardResponses,
  GetAuthSessionData,
  GetAuthSessionResponses,
  GetCompaniesByIdActivityData,
  GetCompaniesByIdActivityResponses,
  GetCompaniesByIdData,
  GetCompaniesByIdDocumentsData,
  GetCompaniesByIdDocumentsResponses,
  GetCompaniesByIdHistoryData,
  GetCompaniesByIdHistoryResponses,
  GetCompaniesByIdProjectsData,
  GetCompaniesByIdProjectsResponses,
  GetCompaniesByIdResponses,
  GetCompaniesData,
  GetCompaniesResponses,
  GetGroupsData,
  GetGroupsResponses,
  GetHealthData,
  GetHealthResponses,
  GetIndexData,
  GetOrganizationsData,
  GetOrganizationsResponses,
  GetPermissionsAuditData,
  GetPermissionsAuditResponses,
  GetPermissionsMatrixData,
  GetPermissionsMatrixResponses,
  GetRolesByIdData,
  GetRolesByIdResponses,
  GetRolesData,
  GetRolesResponses,
  GetUsersByIdData,
  GetUsersByIdPermissionsEffectiveData,
  GetUsersByIdPermissionsEffectiveResponses,
  GetUsersByIdResponses,
  GetUsersData,
  GetUsersMeData,
  GetUsersMeResponses,
  GetUsersResponses,
  PatchCompaniesByIdData,
  PatchCompaniesByIdResponses,
  PatchGroupsByIdData,
  PatchGroupsByIdResponses,
  PatchRolesByIdData,
  PatchRolesByIdResponses,
  PatchUsersByIdData,
  PatchUsersByIdResponses,
  PatchUsersMeData,
  PatchUsersMeResponses,
  PostAuthForgotPasswordData,
  PostAuthLoginData,
  PostAuthLoginResponses,
  PostAuthLogoutData,
  PostAuthRefreshData,
  PostAuthRefreshResponses,
  PostAuthResetPasswordData,
  PostCompaniesByIdDocumentsData,
  PostCompaniesByIdDocumentsResponses,
  PostCompaniesData,
  PostCompaniesResponses,
  PostGroupsByIdMembersData,
  PostGroupsData,
  PostGroupsResponses,
  PostOrganizationsActiveData,
  PostOrganizationsActiveResponses,
  PostOrganizationsData,
  PostOrganizationsResponses,
  PostRolesData,
  PostRolesResponses,
  PostUsersByIdPermissionsDenyData,
  PostUsersByIdPermissionsDenyResponses,
  PostUsersByIdPermissionsGrantData,
  PostUsersByIdPermissionsGrantResponses,
  PostUsersData,
  PostUsersMeAvatarData,
  PostUsersMeAvatarResponses,
  PostUsersMePasswordData,
  PostUsersResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

export class Api {
  /**
   * Health check
   */
  public static getHealth<ThrowOnError extends boolean = false>(
    options?: Options<GetHealthData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/health',
      ...options,
    })
  }
}

export class Api2 {
  /**
   * Login with email and password
   */
  public static postAuthLogin<ThrowOnError extends boolean = false>(
    options: Options<PostAuthLoginData, ThrowOnError>
  ) {
    return (options.client ?? client).post<PostAuthLoginResponses, unknown, ThrowOnError>({
      responseTransformer: postAuthLoginResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/auth/login',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Refresh the access token
   */
  public static postAuthRefresh<ThrowOnError extends boolean = false>(
    options?: Options<PostAuthRefreshData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<PostAuthRefreshResponses, unknown, ThrowOnError>({
      responseTransformer: postAuthRefreshResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/auth/refresh',
      ...options,
    })
  }

  /**
   * Logout the current session
   */
  public static postAuthLogout<ThrowOnError extends boolean = false>(
    options?: Options<PostAuthLogoutData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/auth/logout',
      ...options,
    })
  }

  /**
   * Request a password reset token
   */
  public static postAuthForgotPassword<ThrowOnError extends boolean = false>(
    options: Options<PostAuthForgotPasswordData, ThrowOnError>
  ) {
    return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/auth/forgot-password',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Reset password with a token
   */
  public static postAuthResetPassword<ThrowOnError extends boolean = false>(
    options: Options<PostAuthResetPasswordData, ThrowOnError>
  ) {
    return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/auth/reset-password',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Get the current authenticated user session
   */
  public static getAuthSession<ThrowOnError extends boolean = false>(
    options?: Options<GetAuthSessionData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetAuthSessionResponses, unknown, ThrowOnError>({
      responseTransformer: getAuthSessionResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/auth/session',
      ...options,
    })
  }
}

export class Api3 {
  /**
   * Get the current user profile
   */
  public static getUsersMe<ThrowOnError extends boolean = false>(
    options?: Options<GetUsersMeData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetUsersMeResponses, unknown, ThrowOnError>({
      responseTransformer: getUsersMeResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/me',
      ...options,
    })
  }

  /**
   * Update the current user profile
   */
  public static patchUsersMe<ThrowOnError extends boolean = false>(
    options: Options<PatchUsersMeData, ThrowOnError>
  ) {
    return (options.client ?? client).patch<PatchUsersMeResponses, unknown, ThrowOnError>({
      responseTransformer: patchUsersMeResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/me',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Change the current user password
   */
  public static postUsersMePassword<ThrowOnError extends boolean = false>(
    options: Options<PostUsersMePasswordData, ThrowOnError>
  ) {
    return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/me/password',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Upload the current user avatar
   */
  public static postUsersMeAvatar<ThrowOnError extends boolean = false>(
    options?: Options<PostUsersMeAvatarData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<PostUsersMeAvatarResponses, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/me/avatar',
      ...options,
    })
  }

  /**
   * List users for admin management
   */
  public static getUsers<ThrowOnError extends boolean = false>(
    options?: Options<GetUsersData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetUsersResponses, unknown, ThrowOnError>({
      responseTransformer: getUsersResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/',
      ...options,
    })
  }

  /**
   * Create a managed user
   */
  public static postUsers<ThrowOnError extends boolean = false>(
    options: Options<PostUsersData, ThrowOnError>
  ) {
    return (options.client ?? client).post<PostUsersResponses, unknown, ThrowOnError>({
      responseTransformer: postUsersResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Get a user by ID
   */
  public static getUsersById<ThrowOnError extends boolean = false>(
    options: Options<GetUsersByIdData, ThrowOnError>
  ) {
    return (options.client ?? client).get<GetUsersByIdResponses, unknown, ThrowOnError>({
      responseTransformer: getUsersByIdResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/{id}',
      ...options,
    })
  }

  /**
   * Admin update a user
   */
  public static patchUsersById<ThrowOnError extends boolean = false>(
    options: Options<PatchUsersByIdData, ThrowOnError>
  ) {
    return (options.client ?? client).patch<PatchUsersByIdResponses, unknown, ThrowOnError>({
      responseTransformer: patchUsersByIdResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Get effective permissions for a user
   */
  public static getUsersByIdPermissionsEffective<ThrowOnError extends boolean = false>(
    options: Options<GetUsersByIdPermissionsEffectiveData, ThrowOnError>
  ) {
    return (options.client ?? client).get<
      GetUsersByIdPermissionsEffectiveResponses,
      unknown,
      ThrowOnError
    >({
      responseTransformer: getUsersByIdPermissionsEffectiveResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/{id}/permissions/effective',
      ...options,
    })
  }

  /**
   * Grant a permission to a user
   */
  public static postUsersByIdPermissionsGrant<ThrowOnError extends boolean = false>(
    options: Options<PostUsersByIdPermissionsGrantData, ThrowOnError>
  ) {
    return (options.client ?? client).post<
      PostUsersByIdPermissionsGrantResponses,
      unknown,
      ThrowOnError
    >({
      responseTransformer: postUsersByIdPermissionsGrantResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/{id}/permissions/grant',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Deny a permission for a user
   */
  public static postUsersByIdPermissionsDeny<ThrowOnError extends boolean = false>(
    options: Options<PostUsersByIdPermissionsDenyData, ThrowOnError>
  ) {
    return (options.client ?? client).post<
      PostUsersByIdPermissionsDenyResponses,
      unknown,
      ThrowOnError
    >({
      responseTransformer: postUsersByIdPermissionsDenyResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/{id}/permissions/deny',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Revoke a permission grant
   */
  public static deleteUsersByIdPermissionsByGrantId<ThrowOnError extends boolean = false>(
    options: Options<DeleteUsersByIdPermissionsByGrantIdData, ThrowOnError>
  ) {
    return (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/users/{id}/permissions/{grantId}',
      ...options,
    })
  }
}

export class Api4 {
  /**
   * Get dashboard data for the current user
   */
  public static getApiDashboard<ThrowOnError extends boolean = false>(
    options?: Options<GetApiDashboardData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetApiDashboardResponses, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/dashboard',
      ...options,
    })
  }
}

export class Api5 {
  /**
   * List companies
   */
  public static getCompanies<ThrowOnError extends boolean = false>(
    options?: Options<GetCompaniesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetCompaniesResponses, unknown, ThrowOnError>({
      responseTransformer: getCompaniesResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/companies/',
      ...options,
    })
  }

  /**
   * Create a company
   */
  public static postCompanies<ThrowOnError extends boolean = false>(
    options?: Options<PostCompaniesData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<PostCompaniesResponses, unknown, ThrowOnError>({
      responseTransformer: postCompaniesResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/companies/',
      ...options,
    })
  }

  /**
   * Delete a company
   */
  public static deleteCompaniesById<ThrowOnError extends boolean = false>(
    options: Options<DeleteCompaniesByIdData, ThrowOnError>
  ) {
    return (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/companies/{id}',
      ...options,
    })
  }

  /**
   * Get company details
   */
  public static getCompaniesById<ThrowOnError extends boolean = false>(
    options: Options<GetCompaniesByIdData, ThrowOnError>
  ) {
    return (options.client ?? client).get<GetCompaniesByIdResponses, unknown, ThrowOnError>({
      responseTransformer: getCompaniesByIdResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/companies/{id}',
      ...options,
    })
  }

  /**
   * Update a company
   */
  public static patchCompaniesById<ThrowOnError extends boolean = false>(
    options: Options<PatchCompaniesByIdData, ThrowOnError>
  ) {
    return (options.client ?? client).patch<PatchCompaniesByIdResponses, unknown, ThrowOnError>({
      responseTransformer: patchCompaniesByIdResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/companies/{id}',
      ...options,
    })
  }

  /**
   * Get company projects
   */
  public static getCompaniesByIdProjects<ThrowOnError extends boolean = false>(
    options: Options<GetCompaniesByIdProjectsData, ThrowOnError>
  ) {
    return (options.client ?? client).get<GetCompaniesByIdProjectsResponses, unknown, ThrowOnError>(
      {
        responseTransformer: getCompaniesByIdProjectsResponseTransformer,
        security: [{ scheme: 'bearer', type: 'http' }],
        url: '/companies/{id}/projects',
        ...options,
      }
    )
  }

  /**
   * Get company documents
   */
  public static getCompaniesByIdDocuments<ThrowOnError extends boolean = false>(
    options: Options<GetCompaniesByIdDocumentsData, ThrowOnError>
  ) {
    return (options.client ?? client).get<
      GetCompaniesByIdDocumentsResponses,
      unknown,
      ThrowOnError
    >({
      responseTransformer: getCompaniesByIdDocumentsResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/companies/{id}/documents',
      ...options,
    })
  }

  /**
   * Upload a company document
   */
  public static postCompaniesByIdDocuments<ThrowOnError extends boolean = false>(
    options: Options<PostCompaniesByIdDocumentsData, ThrowOnError>
  ) {
    return (options.client ?? client).post<
      PostCompaniesByIdDocumentsResponses,
      unknown,
      ThrowOnError
    >({
      responseTransformer: postCompaniesByIdDocumentsResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/companies/{id}/documents',
      ...options,
    })
  }

  /**
   * Delete a company document
   */
  public static deleteCompaniesByIdDocumentsByDocumentId<ThrowOnError extends boolean = false>(
    options: Options<DeleteCompaniesByIdDocumentsByDocumentIdData, ThrowOnError>
  ) {
    return (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/companies/{id}/documents/{documentId}',
      ...options,
    })
  }

  /**
   * Get company change history
   */
  public static getCompaniesByIdHistory<ThrowOnError extends boolean = false>(
    options: Options<GetCompaniesByIdHistoryData, ThrowOnError>
  ) {
    return (options.client ?? client).get<GetCompaniesByIdHistoryResponses, unknown, ThrowOnError>({
      responseTransformer: getCompaniesByIdHistoryResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/companies/{id}/history',
      ...options,
    })
  }

  /**
   * Get company activity log
   */
  public static getCompaniesByIdActivity<ThrowOnError extends boolean = false>(
    options: Options<GetCompaniesByIdActivityData, ThrowOnError>
  ) {
    return (options.client ?? client).get<GetCompaniesByIdActivityResponses, unknown, ThrowOnError>(
      {
        responseTransformer: getCompaniesByIdActivityResponseTransformer,
        security: [{ scheme: 'bearer', type: 'http' }],
        url: '/companies/{id}/activity',
        ...options,
      }
    )
  }
}

export class Api6 {
  /**
   * List organizations for the current user
   */
  public static getOrganizations<ThrowOnError extends boolean = false>(
    options?: Options<GetOrganizationsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetOrganizationsResponses, unknown, ThrowOnError>({
      responseTransformer: getOrganizationsResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/organizations/',
      ...options,
    })
  }

  /**
   * Create an organization
   */
  public static postOrganizations<ThrowOnError extends boolean = false>(
    options: Options<PostOrganizationsData, ThrowOnError>
  ) {
    return (options.client ?? client).post<PostOrganizationsResponses, unknown, ThrowOnError>({
      responseTransformer: postOrganizationsResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/organizations/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Set the active organization for the current user
   */
  public static postOrganizationsActive<ThrowOnError extends boolean = false>(
    options: Options<PostOrganizationsActiveData, ThrowOnError>
  ) {
    return (options.client ?? client).post<PostOrganizationsActiveResponses, unknown, ThrowOnError>(
      {
        responseTransformer: postOrganizationsActiveResponseTransformer,
        security: [{ scheme: 'bearer', type: 'http' }],
        url: '/organizations/active',
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
      }
    )
  }
}

export class Api7 {
  /**
   * List role definitions
   */
  public static getRoles<ThrowOnError extends boolean = false>(
    options?: Options<GetRolesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetRolesResponses, unknown, ThrowOnError>({
      responseTransformer: getRolesResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/roles',
      ...options,
    })
  }

  /**
   * Create a new role
   */
  public static postRoles<ThrowOnError extends boolean = false>(
    options: Options<PostRolesData, ThrowOnError>
  ) {
    return (options.client ?? client).post<PostRolesResponses, unknown, ThrowOnError>({
      responseTransformer: postRolesResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/roles',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * List user groups
   */
  public static getGroups<ThrowOnError extends boolean = false>(
    options?: Options<GetGroupsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetGroupsResponses, unknown, ThrowOnError>({
      responseTransformer: getGroupsResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/groups',
      ...options,
    })
  }

  /**
   * Create a user group
   */
  public static postGroups<ThrowOnError extends boolean = false>(
    options: Options<PostGroupsData, ThrowOnError>
  ) {
    return (options.client ?? client).post<PostGroupsResponses, unknown, ThrowOnError>({
      responseTransformer: postGroupsResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/groups',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Get the permission matrix
   */
  public static getPermissionsMatrix<ThrowOnError extends boolean = false>(
    options?: Options<GetPermissionsMatrixData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetPermissionsMatrixResponses, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/permissions/matrix',
      ...options,
    })
  }

  /**
   * Get permission audit entries
   */
  public static getPermissionsAudit<ThrowOnError extends boolean = false>(
    options?: Options<GetPermissionsAuditData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetPermissionsAuditResponses, unknown, ThrowOnError>({
      responseTransformer: getPermissionsAuditResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/permissions/audit',
      ...options,
    })
  }

  /**
   * Delete a role
   */
  public static deleteRolesById<ThrowOnError extends boolean = false>(
    options: Options<DeleteRolesByIdData, ThrowOnError>
  ) {
    return (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/roles/{id}',
      ...options,
    })
  }

  /**
   * Get a role by ID
   */
  public static getRolesById<ThrowOnError extends boolean = false>(
    options: Options<GetRolesByIdData, ThrowOnError>
  ) {
    return (options.client ?? client).get<GetRolesByIdResponses, unknown, ThrowOnError>({
      responseTransformer: getRolesByIdResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/roles/{id}',
      ...options,
    })
  }

  /**
   * Update a role
   */
  public static patchRolesById<ThrowOnError extends boolean = false>(
    options: Options<PatchRolesByIdData, ThrowOnError>
  ) {
    return (options.client ?? client).patch<PatchRolesByIdResponses, unknown, ThrowOnError>({
      responseTransformer: patchRolesByIdResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/roles/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Delete a user group
   */
  public static deleteGroupsById<ThrowOnError extends boolean = false>(
    options: Options<DeleteGroupsByIdData, ThrowOnError>
  ) {
    return (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/groups/{id}',
      ...options,
    })
  }

  /**
   * Update a user group
   */
  public static patchGroupsById<ThrowOnError extends boolean = false>(
    options: Options<PatchGroupsByIdData, ThrowOnError>
  ) {
    return (options.client ?? client).patch<PatchGroupsByIdResponses, unknown, ThrowOnError>({
      responseTransformer: patchGroupsByIdResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/groups/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Add a member to a group
   */
  public static postGroupsByIdMembers<ThrowOnError extends boolean = false>(
    options: Options<PostGroupsByIdMembersData, ThrowOnError>
  ) {
    return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/groups/{id}/members',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  /**
   * Remove a member from a group
   */
  public static deleteGroupsByIdMembersByUserId<ThrowOnError extends boolean = false>(
    options: Options<DeleteGroupsByIdMembersByUserIdData, ThrowOnError>
  ) {
    return (options.client ?? client).delete<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/groups/{id}/members/{userId}',
      ...options,
    })
  }
}

export class Api8 {
  /**
   * Get system activity log
   */
  public static getActivity<ThrowOnError extends boolean = false>(
    options?: Options<GetActivityData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<GetActivityResponses, unknown, ThrowOnError>({
      responseTransformer: getActivityResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/activity',
      ...options,
    })
  }
}

export class Api9 {
  public static getIndex<ThrowOnError extends boolean = false>(
    options?: Options<GetIndexData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/',
      ...options,
    })
  }
}
